const info_produto = document.querySelectorAll('#info_produto');
const produtos = document.querySelectorAll('#produtos');

const hideElement = el => el.style.display = 'none'

const showElement = el => el.style.display = ''

info_produto.forEach(element => {
  hideElement(element);
});

produtos.forEach(element => {
  element.addEventListener('change', e => {
    if(e.target.checked){
      info_produto.forEach(elemento => {
        if (elemento.className === element.value) {
          showElement(elemento);
        }
      });
    }

    if(e.target.checked == false){
      info_produto.forEach(elemento => {
        if (elemento.className === element.value) {
          hideElement(elemento);
        }
      });
    }
  })
});

require('./edit');
